// Hyperscript
function h(tag: string, props: {[key: string]: any} = {}, ...children: any[]) {
    const el = document.createElement(tag);
    for (const [k, v] of Object.entries(props)) {
        if (k.startsWith("on") && typeof v === "function") {
            el.addEventListener(k.slice(2).toLowerCase(), v);
        } else {
            el.setAttribute(k, v);
        }
    }
    for (const c of children) {
        el.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
    }
    return el;
}

// Top Navigation Menu
function dismissMenu() {
    for (const active of document.querySelectorAll('.tn>ul>li.h')) {
        active.classList.remove('h');
    }
}
for (const item of document.querySelectorAll('.tn>ul>li')) {
    item.addEventListener('mouseover', function() {
        item.classList.add('h');
    }, { passive: true });
    item.addEventListener('mouseout', function() {
        item.classList.remove('h');
    }, { passive: true });
    item.addEventListener('touchstart', function(event) {
        if (item.classList.contains('h') || !item.querySelector('li>ul')) return;
        dismissMenu();
        item.classList.add('h');
        event.preventDefault();
    }, { passive: false });
}
document.querySelector('.tn+div')!.addEventListener('click', dismissMenu);

// Scroll Top Button
{
    const button = h('button', {
        class: 'tb',
        onClick: () => window.scrollTo({ top: 0, behavior: 'smooth' }),
    },
        h('span', { class: 'material-symbols-outlined' }, 'arrow_shape_up'),
        h('div', {}, 'ページ上部へ'),
    );
    document.querySelector('body')?.appendChild(button);

    let timer: unknown;
    window.addEventListener("scroll", () => {
        if (!timer) timer = setTimeout(() => {
        if (window.pageYOffset > 300) button.setAttribute('data-show', '');
        else button.removeAttribute('data-show');
        timer = null;
    }, 300);
    }, { passive: true });
}

// Share
window.addEventListener('DOMContentLoaded', () => {
    if (navigator.share) {
        const isApple = /iP(hone|(o|a)d)/.test(navigator.userAgent) || navigator.userAgent.indexOf("Mac OS X") >= 0;
        for (let view of document.querySelectorAll('.sl')) {
            view.prepend(h('a', {
                href: "javascript:void(0)",
                onClick: () => navigator.share({ title: document.title, url: location.href }).catch(() => {}),
                'data-os': '',
            }, h('span', { class: 'material-symbols-outlined' }, isApple ? 'ios_share' : 'share')));
        }
    }
    for (let button of document.querySelectorAll('.sl .j')) {
        button.addEventListener('click', e => {
            e.preventDefault();
            const x = (screen.width - 560) / 2, y = (screen.height - 580) / 2;
            window.open((button as HTMLLinkElement).href, '', `width=560,height=580,left=${x},top=${y}`);
        }, false);
    }
});
